// import React, { useEffect, useState } from 'react';
// import { API } from 'aws-amplify';
// import SensorTimelineChart from "./SensorTimelineChart";

// const params = {
//   headers: {
//     'x-api-key': process.env.REACT_APP_API_KEY,
//     'Accept': 'application/json',
//     'Content-Type': 'application/json',
//   },
// };

// const RadarConnection = () => {
//   const [chartData, setChartData] = useState([]);

//   useEffect(() => {
//     const fetchAssets = async () => {
//       try {
//         const connection = await API.get('assets_connections', '/', params);

//         // Transform data to match expected structure
//         const transformed = connection.map(item => ({
//           asset_id: { S: item.asset_id },
//           history: {
//             L: item.history.map(date => ({ S: date }))
//           },
//           status: { BOOL: item.status }
//         }));

//         setChartData(transformed);
//       } catch (error) {
//         console.error('Error fetching asset connections:', error);
//       }
//     };

//     fetchAssets();
//   }, []);

//   const TOP_N = 15;
//   const ROW_HEIGHT = 400000;


// return (
//   <div
//     className="DeviceMap"
//     style={{
//       maxWidth: "100%",
//       margin: "auto",
//       padding: "2rem",
//     }}
//   >
//     <SensorTimelineChart
//       data={chartData.slice(0, TOP_N)}  // Show only top N
//       height={TOP_N * ROW_HEIGHT}
//       rowHeight={ROW_HEIGHT}
//     />
//   </div>
// );
// };

// export default RadarConnection;


import React, { useState, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Tabs  from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import TabContent from 'react-bootstrap/TabContent';
import { FaEdit, FaAngleLeft, FaCalendarAlt, FaCircle, FaArrowCircleRight  } from "react-icons/fa";
import { API } from 'aws-amplify';
import Moment from 'react-moment';
import moment from 'moment';
import { Link } from 'react-router-dom';
import Map from '../../../components/Map/Map';
import '../Device.css';
import SensorTimelineChart from "../../RadarConnection/SensorTimelineChart";


const headers = {
    'x-api-key': process.env.REACT_APP_API_KEY,
    'Accept': 'application/json',
    'Content-Type': 'application/json',
}

const params = {
    headers: headers,
}

async function addMarkers(map, links) {
    // Import the marker library
    const { AdvancedMarkerElement } = await window.google.maps.importLibrary("marker");
  
    let infoWindow;
    const markers = [];
  
    links.forEach((link) => {
        const icon = document.createElement("img");
        icon.src = link.icon;

        const marker = new AdvancedMarkerElement({
            map,
            position: link.coords,
            title: link.title,
            content: icon,
        });
  
        marker.addListener("click", () => {
            if (infoWindow) {
                infoWindow.close();
            }
  
            infoWindow = new window.google.maps.InfoWindow({
                content: link.content,
            });
    
            infoWindow.open(map, marker);
        });
  
        markers.push({
            id: link.id,
            marker: marker,
        });

    });
  
    return markers;
}


const DeviceInfo = (props) => {
    const [inst_date, setInst_date] = useState('');
    const [expiry_date, setExp_date] = useState('');
    const [isLoading, setLoading] = useState(true);
	const [site, setSite] = useState({});
    const [mapAsset, setMapAsset] = useState([]);
    const [viewMapAssets, setViewMapAssets] = useState([]);
    const [chartData, setChartData] = useState([]);

    // Same Site Assets = SSAssets
    const [mapSSAssets, setMapSSAssets] = useState([]);
    const [SSAssets, setSSAssets] = useState([]);

    const [asset, setAsset] = useState({id: null,
                                        name: '',
                                        make: '',
                                        address: '',
                                        serial_number: '',
                                        sim_card: '',
                                        firmware: '',
                                        location: '',
                                        latitude: '',
                                        longitude: '',
                                        additional_info: '',
                                        inst_date: '',
                                        expiry_date: '',
                                        vpn: '',
                                        status: 'active',
                                        date_created: new Date().toISOString(),
                                        zones: [],
                                        site_id: '',
                                        airscan_id: '',
                                        speed: '',
                                        img: null,
                                        message: ''
                                    });

    const pin_green = "https://maps.google.com/mapfiles/ms/icons/green-dot.png";
    const pin_yellow = "https://maps.google.com/mapfiles/ms/icons/yellow-dot.png";

    let formatDate = ['DD-MM-YYYY','DD/MM/YYYY HH:mm:ss']
    if (props.formatDate!==formatDate[0]){
        formatDate = ['MM-DD-YYYY','MM/DD/YYYY HH:mm:ss']
    }

    // Load asset
    useEffect(()=>{
        
        if (props.match.params.id){
            setLoading(true);
            API.get('asset','/' + props.match.params.id, params)
            .then(res => {

                // Parse dates
                if (res.inst_date === undefined)
                    res.inst_date = ''
                else
                    setInst_date(new Date(res.inst_date))

                if (res.expiry_date === undefined)
                    res.expiry_date = ''
                else
                    setExp_date(new Date(res.expiry_date))

                // Parse zones text
                if (res.zones === undefined ) {
                    res.zones = [];
                    for (let i = 0; i < 26; i++) {
                        res.zones.push({id: 'Zone ' + i, label: ''})
                    }
                } else {
                    for (let i = 0; i < 26; i++) {
                        if (res.zones[i]) {
                            res.zones[i].id = res.zones[i].id || '';
                            res.zones[i].label = res.zones[i].label || '';
                        }else{
                            res.zones.push({id: 'Zone ' + i, label: ''})
                        }
                    }
                }

                // Parse rest params
                if (res.status === undefined)
                    res.status = 'active'

                if (res.speed === undefined)
                    res.speed = 'kph'

                if (res.img === undefined)
                    res.img = null

                setAsset(res);
                setLoading(false);
            });
        
        // WHAT IS EXACTLY "props.match.params.sid"
        //
        // }else{
        //     setLoading(true);
        //     asset.zones = [];
        //     for (let i = 0; i < 26; i++) {
        //         asset.zones.push({id: 'Zone ' + i, label: ''})
        //     }
            
        //     asset.site_id = props.match.params.sid || undefined
        //     if (sites.length>0 && asset.site_id !== undefined) handleSite(asset.site_id)

        //     setAsset(asset);
        //     setLoading(false);
        }
        
    }, [props.match.params.id, props.match.params.sid]);

    useEffect(() => {
        const fetchAssets = async () => {
            try {
                const connection = await API.get('assets_connections', '/', params);
                console.log("get id", props.match.params.id);
    
                // Filter connection data to only match props.match.params.id
                const filteredConnections = connection.filter(item => item.asset_id === props.match.params.id);
    
                // Transform filtered data to match expected structure
                const transformed = filteredConnections.map(item => ({
                    asset_id: { S: item.asset_id },
                    history: {
                        L: item.history.map(date => ({ S: date }))
                    },
                    status: { BOOL: item.status }
                }));
                console.log({transformed})
    
                setChartData(transformed);
            } catch (error) {
                console.error('Error fetching asset connections:', error);
            }
        };
    
        fetchAssets();
    }, [props.match.params.id]);
    

    // Load sites
	useEffect(()=>{
		const fetchSite = async () => {
            let item = await API.get('sites','/' + asset.site_id, params)

            let stat = 'text-success';
            switch (item.status) {
                case 'active': 
                stat = 'text-success'; 
                break;
                case 'inactive': 
                stat = 'text-secondary'; 
                break;      
                case 'removed': 
                stat = 'text-danger'; 
                break;  
                default:
                stat = 'text-success'; 
            }
            item.statusCss = stat;

            setSite(item);
        }  

        if (asset.site_id !== undefined && asset.site_id !== '')
            fetchSite();

    }, [asset]);

    // Load Same Site Assets - SSAssets
	useEffect(()=>{
		const fetchSSAssets = async () => {
            let data = await API.get('site_assets','/' + asset.site_id, params)

            // Give some status color like in site detail
            for (let i = 0; i < data.length; i++) {
                let item = data[i];
                let stat = 'text-success';
                switch (item.status) {
                    case 'active': 
                    stat = 'text-success'; 
                    break;
                    case 'inactive': 
                    stat = 'text-secondary'; 
                    break;      
                    case 'removed': 
                    stat = 'text-danger'; 
                    break;  
                    default:
                    stat = 'text-success'; 
                }
                item.statusCss = stat;
            }

            // Remove the current asset from the list
            setSSAssets(data.filter(item => item.id !== asset.id));
        }  

        if (asset.site_id !== undefined && asset.site_id !== '')
            fetchSSAssets();

    }, [asset]);

    // Load Map Asset
    useEffect(()=>{
        if (asset.id !== undefined && asset.site_id !== '')
            setMapAsset([createMapLink(asset, "asset")])

    }, [asset]);

    // Load Map SSAssets
    useEffect(()=>{
        const addMapSSAssets = () => {
            setMapSSAssets([]);
            SSAssets.forEach(item => {
                if (item.id !== undefined && item.site_id !== '')
                    setMapSSAssets(sites => [...sites, createMapLink(item, "SSA")]);
            })
        }

        if (SSAssets.length > 0)
            addMapSSAssets();

    }, [SSAssets]);

    // Load View Map Assets
    useEffect(()=>{
        if (asset.id != undefined && asset.id != "" && SSAssets.length > 0) {
            setViewMapAssets([...mapAsset, ...mapSSAssets]);
        } else if (asset.id != undefined && asset.id != "") {
            setViewMapAssets([...mapAsset]);
        }

    }, [mapAsset, mapSSAssets]);
    // Store marker references for external access
    const markerRefs = React.useRef({});

    const createMapLink = (assetProp, type) => {
        let icon = pin_green;
        let headerContent;
        if (type === "asset") {
            headerContent = 
                '<span class="map-dev">' +
                    `<p class="text-primary" id="marker-link-${assetProp.id}">${assetProp.name}</p>` +
                '</span>';
            icon = pin_green;
        } else if (type === "SSA") {
            headerContent = 
                '<span class="map-dev">' +
                    `<a href="/device_info/${assetProp.id}" class="text-primary" id="marker-link-${assetProp.id}">${assetProp.name}</a>` +
                '</span><br><br>';
            icon = pin_yellow;
        } 

        let lat = 0;
        let long = 0;
        if (assetProp.latitude) {
            lat = parseFloat(assetProp.latitude)
        }
        if (assetProp.longitude){
            long = parseFloat(assetProp.longitude)
        }
        
        let last_upd = 'Not Available'
        if (assetProp.last_update){
            last_upd = '<span class="text-dark">'+ moment.utc(new Date(assetProp.last_update)).local().format(formatDate[1]) +'</span>';
        }

        // create marker content
        const link = {
            id: assetProp.id,
            coords: { lat: +lat, lng: +long },
            icon: icon,
            content:'<div class="map-div">' +

            headerContent +

            '<span class="text-dark"><strong>'+ assetProp.location  +'</strong></span><br/>' +
            '<span class="text-dark">'+ assetProp.address + ' - ' + last_upd +'</span><br/><br/>' +
            '<span class="text-secondary small">Location: '+ assetProp.latitude  +', '+ assetProp.longitude +'</span><br/>' +
            '</div>'
        }

        return link;
    }
    
    // Add initial coordinates and zoom to the map, it will re-center and resize when it finishes loading assets
    const mapProps = {
        options: { center: { lat: parseFloat(process.env.REACT_APP_MAP_LAT), lng: parseFloat(process.env.REACT_APP_MAP_LNG) }, zoom: 12, scrollwheel: true, mapId: "de70c7e1386f9fba" },

        onMount: async (map, links) => {
            // Use the original addMarkers function
            const markers = await addMarkers(map, links);

            // Store marker references by id for external activation
            markerRefs.current = {};
            markers.forEach(({ id, marker }) => {
                markerRefs.current[id] = marker;
            });
        },
        onMountProps: viewMapAssets,
        className: 'gmaps-asset',
    }

    // Function to activate marker popup externally
    const activateMapMarker = (id) => {
        const marker = markerRefs.current[id];
        if (marker) {
            window.google.maps.event.trigger(marker, 'click');
        }
    };

    // Reload the map only when necessary
    const MemoMap = useCallback(<Map {...mapProps} />, [mapProps])
    const TOP_N = 2000;
    const ROW_HEIGHT = 6000;

	return (
    !isLoading ? (
    <div className="DeviceInfo">
        <div className="col-md-12">
            <div className="row header">
                <div className="col-4">Asset Info</div>
                <div className="col-4 d-flex align-items-end">
                {asset.last_update ?
                    <h5 className='text-secondary'>
                    data updated @&nbsp;
                    <Moment local format={formatDate[0] + " HH:mm:ss"} date={ asset.last_update } className={ moment(asset.last_update).isSameOrAfter(new Date(), "day") ? "text-secondary" : "text-danger" } />
                    </h5>
                :''}
                </div>
                <div className="col-4 d-flex justify-content-end">
                    <Button variant="secondary" className="mr-1 text-nowrap" onClick={()=>{props.history.goBack()}}>
                        Back &nbsp;
                        <FaAngleLeft />
                    </Button>
                    {(props.viewPermissions.find(i => i === 'view_asset'))?
                    <Link to={`/device_det/${asset.id}`} className="btn btn-success mr-1 text-nowrap">
                        Edit &nbsp;
                        <FaEdit />
                    </Link>
                    :''} 
                    {(props.viewPermissions.find(i => i === 'edit_asset') && site.vpn && asset.mqtt_chk)? 
                    <a href={'http://' + site.vpn + '/'} target='blank' className='btn btn-warning mr-1 text-nowrap p-2'>
                        Traffic Web UI &nbsp;
                        <FaArrowCircleRight />
                    </a>     
                    :''}
                </div>
            </div>
          
            <div className="row div-content">
                <div className="col-md-12">
                    <Tabs defaultActiveKey="details" transition={false} id="asset_det">
                        <Tab eventKey="details" title="Details">
                            <TabContent className="p-3" >

                                {/* ASSET DET START */}
                                <div className="row"> 
                                    <div className="col-md-2 pb-1">
                                        <Form.Group controlId="serial_number">
                                            <Form.Label><strong>ID / Serial Number</strong></Form.Label>
                                            <div className="form-control-plaintext">{asset.serial_number || '-'}</div>
                                        </Form.Group>
                                    </div>

                                    <div className="col-md-6 pb-1">
                                        <Form.Group controlId="name">
                                            <Form.Label><strong>Name</strong></Form.Label>
                                            <div className="form-control-plaintext">{asset.name || '-'}</div>
                                        </Form.Group>
                                    </div>

                                    <div className="col-md-2 pb-1">
                                        <Form.Group controlId="status">
                                            <Form.Label><strong>Status</strong></Form.Label>
                                            <div className="form-control-plaintext text-capitalize">{asset.status || '-'}</div>
                                        </Form.Group>
                                    </div>

                                    <div className="col-md-2 pb-1">
                                        <Form.Group controlId="make">
                                            <Form.Label><strong>Make</strong></Form.Label>
                                            <div className="form-control-plaintext">{asset.make || '-'}</div>
                                        </Form.Group>
                                    </div>

                                    <div className="col-md-2 pb-1">
                                        <Form.Group controlId="sim_card">
                                            <Form.Label><strong>SIM Card Number</strong></Form.Label>
                                            <div className="form-control-plaintext">{asset.sim_card || '-'}</div>
                                        </Form.Group>
                                    </div>

                                    <div className="col-md-2 pb-1">
                                        <Form.Group controlId="firmware">
                                            <Form.Label><strong>Firmware</strong></Form.Label>
                                            <div className="form-control-plaintext">{asset.firmware || '-'}</div>
                                        </Form.Group>
                                    </div>

                                    <div className="col-md-2 pb-1">
                                        <Form.Group>
                                            <Form.Label htmlFor="inst_date">
                                                <FaCalendarAlt className="text-secondary" />
                                                <strong>Installation Date</strong>
                                            </Form.Label>
                                            <div className="form-control-plaintext">
                                            {inst_date ? inst_date.toLocaleDateString() : '-'}
                                            </div>
                                        </Form.Group>
                                    </div>

                                    <div className="col-md-2 pb-1">
                                        <Form.Group>
                                            <Form.Label htmlFor="expiry_date">
                                                <FaCalendarAlt className="text-secondary" />
                                                <strong>Expiry Date</strong>
                                            </Form.Label>
                                            <div className="form-control-plaintext">
                                            {expiry_date ? expiry_date.toLocaleDateString() : '-'}
                                            </div>
                                        </Form.Group>
                                    </div>

                                    <div className="col-md-2 pb-1">
                                        <Form.Group controlId="vpn">
                                            <Form.Label><strong>VPN</strong></Form.Label>
                                            <div className="form-control-plaintext">{asset.vpn || '-'}</div>
                                        </Form.Group>
                                    </div>

                                    <div className="col-md-2 pb-1">
                                        <Form.Group controlId="speed">
                                            <Form.Label><strong>Speed</strong></Form.Label>
                                            <div className="form-control-plaintext">{asset.speed || '-'}</div>
                                        </Form.Group>
                                    </div>

                                    <div className="col-md-8 pb-1">
                                        <Form.Group controlId="additional_info">
                                            <Form.Label><strong>Additional Information</strong></Form.Label>
                                            <div className="form-control-plaintext" style={{ whiteSpace: 'pre-wrap' }}>
                                            {asset.additional_info || '-'}
                                            </div>
                                        </Form.Group>
                                    </div>

                                    <div className="col-md-2 pb-1">
                                        <Form.Group controlId="latitude">
                                            <Form.Label><strong>GPS Latitude</strong></Form.Label>
                                            <div className="form-control-plaintext">{asset.latitude || '-'}</div>
                                        </Form.Group>
                                    </div>

                                    <div className="col-md-2 pb-1">
                                        <Form.Group controlId="longitude">
                                            <Form.Label><strong>GPS Longitude</strong></Form.Label>
                                            <div className="form-control-plaintext">{asset.longitude || '-'}</div>
                                        </Form.Group>
                                    </div>

                                </div>

                                {/* ASSET SITE DETAILS END */}
                                <div className="row border-bottom bg-white border-top"> 

                                    <div className="col-md-1 bg-light text-secondary py-2">Site</div>
                                    <div className="col-md-2 py-2">{site.name || '-'}</div>
                                            

                                    <div className="col-md-1 bg-light text-secondary py-2">Address</div>
                                    <div className="col-md-2 py-2">{site.address}</div>
                                            
                                    <div className="col-md-1 bg-light text-secondary py-2">Country</div>
                                    <div className="col-md-1 py-2">{site.country}</div>
                                    
                                    <div className="col-md-1 bg-light text-secondary py-2">Location</div>
                                    <div className="col-md-1 py-2">{site.location}</div>
                                    
                                    <div className="col-md-1 bg-light text-secondary py-2">Status</div>
                                    <div className={"col-md-1 py-2 small " + site.statusCss}><FaCircle/> { site.status }</div>
                                
                                </div>

                                <div className="row">
                                    {/* Map column */}
                                    <div className="col-md-6" style={{ minHeight: '400px' }}>
                                        {MemoMap}
                                        <div className="mt-2">
                                            <img src={pin_green} alt="" height="16" width="16" /> Asset
                                            {SSAssets.length > 0 ? (
                                                <>
                                                    {' '}| <img src={pin_yellow} alt="" height="16" width="16" /> Same Site Assets
                                                </>
                                            ) : null}
                                        </div>
                                    </div>

                                    {/* SensorTimelineChart column */}
                                    <div className="col-md-6" style={{ minHeight: '400px' }}>
                                        <div style={{ width: '100%', overflow: 'hidden' }}>
                                            <SensorTimelineChart
                                                data={chartData.slice(0, TOP_N)}
                                                height={TOP_N * ROW_HEIGHT}
                                                rowHeight={ROW_HEIGHT}
                                            />
                                        </div>
                                    </div>
                                </div>

                                {/* SAME SITE ASSETS SSA - DETAILS LIST */}
                                <div className="row scroller m-auto pt-2" style={{ width: '94%' }}>
                                    {(SSAssets.length > 0) ? (
                                        <>
                                        <div className="row">
                                            <div className="col-md-12 text-secondary py-2">Same Site Assets</div>
                                        </div>
                                    
                                        {SSAssets.map((item, i) => (
                                            <div className="row border-bottom bg-white border-top w-100 selectableItem" onClick={() => {activateMapMarker(item.id)}}> 

                                                <div className="col-md-1 bg-light text-secondary py-2">Asset</div>
                                                <div className="col-md-5 py-2">{item.name || '-'}</div>
                                                        
                                                <div className="col-md-1 bg-light text-secondary py-2">Country</div>
                                                <div className="col-md-1 py-2">{item.country}</div>

                                                <div className="col-md-1 bg-light text-secondary py-2">Location</div>
                                                <div className="col-md-1 py-2">{item.location}</div>

                                                <div className="col-md-1 bg-light text-secondary py-2">Status</div>
                                                <div className={"col-md-1 py-2 small " + item.statusCss}><FaCircle/> { item.status }</div>

                                            </div>
                                        ))}
                                        </>
                                    ) : ('')}
                                </div>
                                                        
                            </TabContent>
                        </Tab>
                        {(props.viewPermissions.find(i => i === 'edit_zones'))?
                        <Tab eventKey="zones" title="Zones">
                            <TabContent className="p-3" >
                            <div className="row">
                                {[...Array(26)].map((_, i) => {
                                    const zoneLabel = asset.zones[i]?.label;
                                    if (!zoneLabel) return null; // Skip empty zones

                                    return (
                                    <div className="col-md-4 d-flex p-2" key={`zones_${i}`}>
                                        <div className="col-md-2 p-1"><strong>Zone {i}</strong></div>
                                        <div className="col-md-10 p-1">{zoneLabel}</div>
                                    </div>
                                    );
                                })}
                            </div>

                            </TabContent>
                        </Tab>
                        :''}

                        <Tab eventKey="docs" title="Images">
                            <TabContent className="p-3" >
                                <div className="row">
                                    <div className="col-md-8">
                                        {(asset.img)?
                                        <img
                                            src={asset.img}
                                            // src={asset.img}
                                            className="d-inline-block align-top rounded"
                                            alt="Sensor Diagram"
                                            width="100%"
                                        />
                                        :'No available image'}
                                    </div>
                                </div>
                            </TabContent>
                        </Tab>
                    </Tabs>
                </div>
            </div>
        </div>

    </div>
    ) : ''
    );
}

const mapStateToProps = state => {
    return {
        user: state.auth.user,
        formatDate: state.auth.formatDate,
        viewPermissions: state.auth.viewPermissions,
    };
  };

export default connect(mapStateToProps)(DeviceInfo);
